import {AfterContentInit, Component, ContentChildren, Input, QueryList} from "@angular/core";
import {TabComponent} from "./tab.component";
import {Router} from "@angular/router";

// TODO s.bavykin Add a possibility to support permissions for tab
@Component({
    selector: 'tfl-bo-dynamic-tab-holder',
    template: `
        <panel title="{{ panelTitle }}" class="tab-panel">
            <div class="row tab-headers">
                <div class="tab-header col-xs-2 text-center"
                     *ngFor="let tab of tabs"
                     (click)="selectTab(tab)" [class.selected]="tab.active">
                    {{ tab.title }}
                </div>
            </div>

            <ng-content></ng-content>
        </panel>
    `
})
export class DynamicTabHolderComponent implements AfterContentInit {

    private path:string;

    @Input() panelTitle: string;

    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

    constructor(private _router: Router) {
    }

    ngAfterContentInit() {
        let activeTabs = this.tabs.filter(tab => tab.active);
        let tabForActivation;
        // bind tab activation to router path
        this.path = this._router.url.toString().substring(this._router.url.lastIndexOf('/') + 1);
        tabForActivation =  this.tabs.filter(tab => tab.title.toLowerCase() == this.path.replace('-',' '))[0];
        if (activeTabs.length === 0) {
            this.selectTab(tabForActivation);
        }
    }

    selectTab(tab: TabComponent) {
        this.tabs.toArray().forEach(t => t.active = false);

        // activate specified tab
        if (tab) {
            tab.active = true;
            this._router.navigate(tab.navigationPoint);
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/bo-tabs/tab-holder.component.ts